import React, { Component } from 'react';
import tr from '../../../libs/tr';
import ReactLoading from 'react-loading';
import './FullViewBar.css';
import scalendar from '../../../images/public/userarea/scalendar.png';
import slocation from '../../../images/public/userarea/slocation.png';
import alertb from '../../../images/public/userarea/alertb.png';

class FullViewBar extends Component {

    constructor(props) {
        super(props);

        this.textlast = props.textlast ? props.textlast : "Text missing!";
        this.allMovements = props.allMovements ? props.allMovements : false;

        this.state = {
            Alertfvb: props.movement ? props.movement.alert : false,

            // Datelast: props.movement.dateTo,
            // // Banknumberlast: "*5036",
            // Cardtypelast: ' - ' + props.Cardtypelast,
            // Location: props.movement.comprensorio,
            // Costlast: props.movement.paid,
            // Duration: props.movement.val_accesso,

            date: props.movement.date,
            fullname: props.movement.fullname,
            skiresort: props.movement.skiresort,
            cost: props.movement.cost,
            duration: props.movement.duration,
            Cardtypelast: props.movement.Cardtypelast,
        };
    }

    handleAlert=()=>{
        //user has to modify payment method
        this.props.onAlert();
    }
    render() {
        return (
        <div className="fullviewBar">
          <div className="row">
            <div className="col-12 col-md-6 col-lg d-flex align-items-center justify-content-center mb-3 mb-lg-0">
              <div className="calDate">
                <div className="calendar">
                    <img src={scalendar} className="img-fluid"/>
                </div>
                <p style={{marginBottom: 0}}>{ this.state.date }</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg mb-3 mb-lg-0 d-flex align-items-center justify-content-center">
              <div className={this.allMovements ? "fullviewNamenumtypeAll" : "fullviewNamenumtype"}>
                  {this.state.fullname}<div className="txtStylefv">{this.allMovements ? '' : this.state.Cardtypelast}</div>
              </div>
            </div>
            {!this.allMovements &&
            <div className="col-12 col-md-6 col-lg mb-3 mb-lg-0 d-flex align-items-center justify-content-center">
                <div className="location">
                    <div className="locationSign">
                        <img src={slocation} className="img-fluid" />
                    </div>
                    &#160;{this.state.skiresort}
                </div>
            </div>
            } 
            <div className="col-12 col-md-6 col-lg mb-3 mb-lg-0 d-flex align-items-center justify-content-center">
              <div className={this.allMovements ? "costAll" : "cost"}>
                
                {this.state.Alertfvb ?
                    <button className="btnAlert mr-3" onClick={()=>{ this.handleAlert()}}>
                        <img  src={alertb} className="img-fluid" />
                    </button> : null
                }
                {tr.t("currency")} {this.state.cost}
              </div>

            </div>
            {!this.allMovements &&
            <div className="col-12 col-md-6 col-lg mb-3 mb-lg-0 d-flex align-items-center justify-content-center">
                  <div className="duration">
                      {this.state.duration}
                  </div>
            </div>
            } 
          </div>
            
          <div className="underLine my-3 my-lg-5" />
        </div>
            // <div className="fullviewBar" style={{ flex: 1 }}>
            //     <div className="calDate">
            //         <div className="calendar">
            //             <img src={scalendar} className="img-fluid" />
            //         </div>
            //         {this.state.date}
            //     </div>
            //     <div className={this.allMovements ? "fullviewNamenumtypeAll" : "fullviewNamenumtype"} style={{ flex: 1 }}>
            //         {this.state.fullname}&#160;<div className="txtStylefv">{this.allMovements ? '' : this.state.Cardtypelast}</div>
            //     </div>
            //     {!this.allMovements &&
            //         <div className="location" style={{ flex: 1 }}>
            //             <div className="locationSign">
            //                 <img src={slocation} className="responsive" />
            //             </div>
            //             &#160;{this.state.skiresort}
            //         </div>
            //     }
            //     <div className={this.allMovements ? "costAll" : "cost"}>
            //         {tr.t("currency")} {this.state.cost}
            //         {this.state.Alertfvb ?
            //             <div className="fullalert">
            //                 <img onClick={()=>{ this.handleAlert()}} src={alertb} className="responsive" />
            //             </div> : null
            //         }
            //     </div>
            //     {!this.allMovements &&
            //         <div className="duration">
            //             {this.state.duration}
            //         </div>
            //     }
            //     <div className="underLine" style={{ flex: 1 }} />
            // </div>
        );
    }
}

export default FullViewBar;


// WEBPACK FOOTER //
// ./src/assets/components/panel/FullViewBar.js